import React from 'react';
import { compose, prop, equals } from 'ramda';
import { FormattedMessage } from 'react-intl';

import renderIf from 'app/enhancers/renderIf';
import { userCountryCode } from 'app/features/user/selectors';
import Text from 'app/components/layout/Text.styled';
import S from 'app/features/footer/components/Footer.styled';
import connect from 'app/libs/connect';
import { TRANSPARENCY_STATEMENT_URL } from 'app/router/constants/externalUrls';

const UI = () => (
  <>
    <S.FooterLinkDivider />
    <Text
      as={S.FooterLink}
      size="l"
      type="semibold"
      href={TRANSPARENCY_STATEMENT_URL}
      target="_blank"
      data-t="transparency-statement"
    >
      <FormattedMessage id="footer_transparency_statement" />
    </Text>
  </>
);

const ModernSlavery = compose(
  connect({ userCountryCode }),
  renderIf(compose(equals('GB'), prop('userCountryCode'))),
)(UI);

export { UI };

export default ModernSlavery;
